import * as React from "react";
function SvgBangFat(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10 10"
      ref={svgRef}
      {...props}
    >
      <path d="M5 7c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v5c0 .6-.4 1-1 1z" />
      <circle cx={5} cy={9} r={1} />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBangFat);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
